import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid, Drawer, Divider, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DashboardWrapper from "../containers/DashboardWrapper";
import {
  setCurrentPage,
  getImageDataByFileName,
  getSavedSelectedReportTagDataByReportId,
  getSavedSelectedReportStatusDataByReportId,
  setPeriodType,
  setDrawerTagTip,
  getSavedCommentDataByFileName,
  getImageDataByReportId,
} from "../actions";
import ImageMeta from "../components/Viewer/ImageMeta";
import ReportMeta from "../components/Viewer/ReportMeta";
import ReportMagnify from "../components/Viewer/ReportMagnify";
import ImageMagnify from "../components/Viewer/ImageMagnify";
import TagConfig from "../config/TagConfig";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  contentGrid: {
    marginTop: theme.spacing(0),
    display: 'flex',
    justifyContent: 'center',  // 中央揃え
    alignItems: 'center',
  },
  imageMeta: {
    marginTop: 0,
    marginBottom: 8,
    maxWidth: 1200,
    width: '100%',           // 横幅を100%に
    marginLeft: 'auto',      // 左右中央に配置
    marginRight: 'auto',
  },
  centeredContainer: {
    display: 'flex',
    justifyContent: 'center', // 中央揃え
    alignItems: 'center',
    width: '98%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    top: 62,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  tagTextWrapper: {
    padding: "16px",
  },
  tagTip: {
    fontWeight: "bold",
    marginBottom: 16,
  },
  tagText: {
    fontSize: "14px",
    marginBottom: 16,
  },
  noImagePlaceholder: {
    padding: theme.spacing(2),
    border: "1px dashed #ccc",
    borderRadius: "8px",
    color: "#666",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: theme.spacing(4),
  },
}));

const ReportViewer = ({
  pageTopLoader,
  setCurrentPage,
  getImageDataByFileName,
  filterDrawerState,
  viewer,
  viewerImageData,
  viewerImageDataExtra,
  getSavedSelectedReportTagDataByReportId,
  getSavedSelectedReportStatusDataByReportId,
  getSavedCommentDataByFileName,
  setPeriodType,
  setDrawerTagTip,
  periodType,
  openTagTip,
  getImageDataByReportId,
  reportImageData,
  reportImageDataByOthers,
  reportNoImageData,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [tagData, setTagData] = useState([]);
  const [othersImage, setOthersImage] = useState([]);
  const [numOfImageValue, setNumOfImageValue] = useState(false);

  useEffect(() => {
    setCurrentPage(window.location.pathname);

    // URLパスからReportIDを取得
    const pathParts = window.location.pathname.split("/");
    const encodedFileName = pathParts[pathParts.length - 1];
    const reportId = decodeURIComponent(encodedFileName);
    if (reportId) {
      getImageDataByReportId(reportId);
      getSavedSelectedReportTagDataByReportId(reportId);
      getSavedSelectedReportStatusDataByReportId(reportId);
    }
    setTagData(TagConfig.reportResultTagTip);
  }, []);

  useEffect(() => {
    if (viewerImageData.length > 0 && viewerImageData[0] !== undefined) {
      const viewerKey = viewerImageData[0]?.object_key;
      let filteredOthers = reportImageDataByOthers;
      if (
        reportImageDataByOthers.length > 0 &&
        reportImageDataByOthers[0]?.object_key === viewerKey
      ) {
        filteredOthers = reportImageDataByOthers.slice(1);
      }
      setOthersImage(filteredOthers);
    } else {
      setOthersImage(reportImageDataByOthers);
    }
  }, [viewerImageData, reportImageDataByOthers]);

  const onSetNumOfImage = (value) => {
    setNumOfImageValue(value);
  };

  return (
    <DashboardWrapper>
      <Grid container spacing={0} direction="row" justifyContent="center">
        <Grid item xs={12}>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            className={classes.contentGrid}
          >
            <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
              <ReportMeta viewer={reportImageData} />
            </Grid>
            {reportNoImageData &&
            <>
              <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
                <div className={classes.noImagePlaceholder}>報告画像はありません</div>
              </Grid>
              <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer} style={{ marginBottom: 20 }}>
                <Typography variant="body3" component="p">
                  同一アセットが撮られた他の参考写真
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
                {reportImageDataByOthers[0] !== undefined &&
                  <ImageMeta viewer={[reportImageDataByOthers[0]]} noInput={true} numOfImage={numOfImageValue} />
                }
              </Grid>
            </>
            }
            <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
              {reportImageData && reportImageData.length > 0 ? (
                <ReportMagnify viewer={reportImageData} onSetNumOfImage={onSetNumOfImage} />
              ) : null}
            </Grid>
            {!pageTopLoader &&
              <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  spacing={2}
                  style={{ overflowY: "auto", marginTop: 20 }} // スクロールを有効に
                >
                  {viewerImageDataExtra && viewerImageDataExtra.length > 0 &&
                  <>
                    <Grid item xs={12} style={{ marginBottom: 20 }}>
                      <Typography variant="body3" component="p">
                        同一アセットが撮られた他の参考写真
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
                      <ImageMeta viewer={[reportImageDataByOthers[0]]} noInput={true} numOfImage={viewerImageDataExtra.length} />
                    </Grid>
                    <Grid item xs={12} md={12} lg={10} className={classes.centeredContainer}>
                      <ImageMagnify viewer={viewerImageDataExtra} />
                    </Grid>
                  </>
                  }
                  {reportImageDataByOthers.length === 0 &&
                    <Grid item xs={12} container justifyContent="center" spacing={0}>
                      <Typography variant="body2" component="p">
                        他の撮影写真データはありません
                      </Typography>
                    </Grid>
                  }
                </Grid>
              </Grid>
            }
          </Grid>
        </Grid>
      </Grid>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={openTagTip}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={() => setDrawerTagTip(false)}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <div className={classes.tagTextWrapper}>
          {tagData.length > 0 && (
            <>
              <div className={classes.tagTip}>
                ツルツタ報告確認結果タグ
              </div>
              {tagData.length > 0 &&
                tagData.map((row, index) => (
                  <div className={classes.tagText} key={index}>
                    {row["tip"]}
                  </div>
                ))}
            </>
          )}
        </div>
      </Drawer>
    </DashboardWrapper>
  );
};

ReportViewer.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.app.pageTopLoader,
  filterDrawerState: state.app.filterDrawerState,
  viewer: state.viewer.imageDataByFilename,
  viewerImageData: state.viewer.viewerImageData,
  viewerImageDataExtra: state.viewer.viewerImageDataExtra,
  periodType: state.app.periodType,
  openTagTip: state.app.openTagTip,
  reportImageData: state.report.reportImageData,
  reportImageDataByOthers: state.report.reportImageDataByOthers,
  reportNoImageData: state.report.reportNoImageData,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getImageDataByFileName: (param) => dispatch(getImageDataByFileName(param)),
  getSavedSelectedReportTagDataByReportId: (param) => dispatch(getSavedSelectedReportTagDataByReportId(param)),
  getSavedSelectedReportStatusDataByReportId: (param) => dispatch(getSavedSelectedReportStatusDataByReportId(param)),
  getSavedCommentDataByFileName: (param) => dispatch(getSavedCommentDataByFileName(param)),
  setPeriodType: (param) => dispatch(setPeriodType(param)),
  setDrawerTagTip: (param) => dispatch(setDrawerTagTip(param)),
  getImageDataByReportId: (param) => dispatch(getImageDataByReportId(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewer);
